import * as dayjs from "dayjs";

export function convertDate(date: any, format: string) {
    if(!date) { return ""; }
    switch(format) {
        case "post": return dayjs(date).format("MMM DD, YYYY @ hh:mm A");
    }
    return dayjs(date).format("MM/dd/yyyy");
}